module.exports = __webpack_public_path__ + "img/38e910db3305fb4680d9db649f81abfa.png";